import {Cell} from "../../../Cell";


export class Operation {

    constructor({leftColumn, rightColumn}) {
        /**
         * @type {Object} columnDef - The definition of the column this operation applies to.
         */
        this.leftColumn = leftColumn;
        this.rightColumn = rightColumn;
    }

    static symbol = "";

    displayName() {
        return `${this.leftColumn.displayName} ${this.constructor.symbol} ${this.rightColumn.displayName}`;
    }

    getOperands(row) {
        // const leftCell = row.cells[this.leftColumn.getIndex()];
        // const rightCell = row.cells[this.rightColumn.getIndex()];
        const leftCell = row.cells.find(cell => cell.getIndex() === this.leftColumn.getIndex());
        const rightCell = row.cells.find(cell => cell.getIndex() === this.rightColumn.getIndex());

        if (!(leftCell instanceof Cell) || !(rightCell instanceof Cell)) {
            let message = `Missing cells for operation: ${this.displayName()}\n`;
            message += `\nSearched Indexes: \n${row.cells.map(cell => `    - ${cell.columnDef.getIndex()}`).join("\n")}`;
            message += `\nFor Left Index: ${this.leftColumn.getIndex()}, Right Index: ${this.rightColumn.getIndex()}, nCells=${row.cells.length}\n`;
            console.error(message);
        }

        const leftValue = leftCell?.getSortValue();
        const rightValue = rightCell?.getSortValue();

        return [leftValue, rightValue];
    }

    perform(row) {
        /*
        This method should be overridden by subclasses to perform the specific operation.

        .perform(leftValue, rightValue) is called on each row for a given group. It's used to calculate values across
            columns. leftValue and rightValue are required, otherwise people should use the Aggregator class.

         */
        // const leftValue = row.cells[this.leftColumnDef.index].getSortValue();
        // const rightValue = row.cells[this.rightColumnDef.index].getSortValue();
    }
}

export default Operation;